export default "__VITE_ASSET__BHZbJb0A__"